import {
  ADD_CLIP,
  MOVE_CLIP,
  REMOVE_CLIP,
  SET_SAVING,
  SET_FEEDBACK_SAVED,
  SET_FEEDBACK_SAVING,
  SET_TITLE,
  SET_HIGHLIGHT_REEL,
  SET_MAXTIME_MODAL,
  OPEN_CLIP_MODAL,
  CLOSE_CLIP_MODAL,
} from './reducer';

export const setFeedbackSaving = () => (dispatch) => {
  const payload = {
    feedback: 'Saving...',
    touched: true,
  };

  dispatch({
    type: SET_FEEDBACK_SAVING,
    payload,
  });
};

export const setFeedbackSaved = () => (dispatch) => {
  const payload = {
    feedback: 'Highlight reel saved!',
    touched: true,
  };

  dispatch({
    type: SET_FEEDBACK_SAVED,
    payload,
  });
};

export const setSaving = () => (dispatch) => {
  dispatch({
    type: SET_SAVING,
  });
};

export const setTitle = (title) => (dispatch) => {
  setFeedbackSaving()(dispatch);

  dispatch({
    type: SET_TITLE,
    payload: {
      title,
    },
  });
};

export const addClip = (testSessionNote, highlightReelId, index, clips) => (dispatch) => {
  // We can't add new clips if sum of all clips duration is greater than 45 minutes
  const MAX_MINUTES = 45;
  const MIN_TO_SEC = MAX_MINUTES * 60;
  const { videoEndTime, videoStartTime } = testSessionNote;
  const clipTime = videoEndTime - videoStartTime;
  const currentDuration = clips.reduce((prev, next) => (
    prev + (next.testSessionNote.videoEndTime - next.testSessionNote.videoStartTime)
  ), 0);
  const durationWithNewClip = currentDuration + clipTime;
  const maxTimeModalOpened = (durationWithNewClip > MIN_TO_SEC);

  if (maxTimeModalOpened) {
    dispatch({
      type: SET_MAXTIME_MODAL,
      payload: {
        maxTimeModalOpened,
      },
    });
  } else {
    setFeedbackSaving()(dispatch);
    const clip = {
      testSessionNote,
      clipOrder: index,
      highlightReelId,
    };

    dispatch({
      type: ADD_CLIP,
      payload: {
        clip,
      },
    });
  }
};

export const closeMaxTimeModal = () => (dispatch) => {
  dispatch({
    type: SET_MAXTIME_MODAL,
    payload: {
      maxTimeModalOpened: false,
    },
  });
};

export const removeClip = (index) => (dispatch) => {
  setFeedbackSaving()(dispatch);

  dispatch({
    type: REMOVE_CLIP,
    payload: {
      index,
    },
  });
};

export const moveClip = (oldIndex, newIndex) => (dispatch) => {
  setFeedbackSaving()(dispatch);

  dispatch({
    type: MOVE_CLIP,
    payload: {
      oldIndex,
      newIndex,
    },
  });
};

export const setHighlightReel = (highlightReel) => (dispatch) => {
  dispatch({
    type: SET_HIGHLIGHT_REEL,
    payload: {
      highlightReel,
    },
  });
};

export const openClipModal = (selectedNoteId) => (dispatch) => {
  dispatch({
    type: OPEN_CLIP_MODAL,
    payload: {
      selectedNoteId,
    },
  });
};

export const closeClipModal = () => (dispatch) => {
  dispatch({
    type: CLOSE_CLIP_MODAL,
  });
};
